
<template>
    <div class='knowledge-rhtype'>
        <div class="top-title">润滑点类型配置</div>
        <Card dis-hover>
            <Alert closable>
                <Icon type="md-information-circle" />
                请在物联网平台建立润滑点类型
                <a href="https://help.aliyun.com/document_detail/73728.html" target="_blank">查看用户指南</a>
            </Alert>
            <div class="rhcontentWrap">
                <div class="left-types">
                    <Input v-model='dataForm.name' @on-change="changeSearch" prefix="ios-search" placeholder="搜索润滑点类型..."/>
                    <Tabs @on-click="clickTab" :value="rhDetails.status === 1 ? 'inited' : 'uninit'">
                        <TabPane label="已初始化" name="inited">
                            <ul class="rh-lists">
                                <li 
                                    v-for="(inited,index) in listsY" 
                                    :key="index"
                                    @click="showRhDetails(inited,index)"
                                    :class="curRh === index ? 'cur' : ''"
                                >
                                    {{inited.name}} ({{inited.code}})
                                </li>
                            </ul>
                            <div v-if="!dataLists.length" class="no-datas">无数据</div>
                        </TabPane>
                        <TabPane label="未初始化" name="uninit">
                            <ul class="rh-lists">
                                <li 
                                    v-for="(inited,index) in listsN" 
                                    :key="index"
                                    @click="showRhDetails(inited,index)"
                                    :class="curRh === index ? 'cur' : ''"
                                >
                                    {{inited.name}}
                                </li>
                            </ul>
                            <div v-if="!dataLists.length" class="no-datas">无数据</div>
                        </TabPane>
                    </Tabs>
                </div>
                <div class="right-table">
                    <div class="rh-title">{{rhDetails.name}}</div>
                    <div class="rh-desc">
                        <p class="rh-tit">
                            <span>润滑点类型的设备数量</span>
                            <span>{{rhDetails.oilSiteCount}}</span>
                        </p>
                        <p class="rh-num">
                            <span>创建时间</span>
                            <span>{{rhDetails.gmtCreate}}</span>
                        </p>
                    </div>

                    <div class="rh-init" v-if="rhDetails.status === 1">
                        <p class="rh-tit">润滑点类型编号</p>
                        <div class="rh-update" >
                           <p>
                          <Input :disabled="lubiacation" v-model="updatecode" placeholder="请输入类型编码" style="width:200px"/>
                       </p>
                        <span @click="lubiacation=false" v-if="lubiacation" style="" >编辑</span>
                        <span @click="updatebia(rhDetails)"  v-else >确定</span>
                        </div>
                      
                        <!-- <p>{{rhDetails.code}}</p> -->
                    </div>
                    <div class="rh-init" v-else>
                        <p class="rh-tit">润滑点类型编号</p>
                        <Input v-model="rhTypeNum" placeholder="请输入类型编码" style="width:200px"/>
                        <span @click="initRhCodePop(rhDetails)" class="btn-init">初始化</span>
                    </div>

                    <!-- v-if='dataLists.length' -->
                    <div class="lists clearfix">
                        <!-- 列表 -->
                        <div class="common-list">
                            <Table class="equipmentTable" :columns="dataColumn" :data="rhDetails.oilSiteTypeModelList"></Table>
                        </div>
                    </div>
                </div>
            </div>
            
        </Card>

        <OilDrawer 
            ref="oilDrawer"
            :showDrawer="showDrawer" 
            :closeDrawer="closeDrawer" 
            :dataCenter="dataCenter"
            :getLists="getLists"
            :curItemDetail="curItemDetail"
        ></OilDrawer>

    </div>
</template>

<script>
import api from "@/api";
import ls from "store2";
import deepcopy from "deepcopy";
import { mapState } from 'vuex';
import handleSelItem from "@/mixins/handleSelItem"
import OilDrawer from "./components/oil-drawer.vue"

export default {
    name: "knowledge-rhtype",
    mixins: [handleSelItem],
    components: {
        OilDrawer
    },
    computed:{
        ...mapState({
            dataCenter: state=>state.dataCenter
        })
    },
    data() {
        return {
            dataLists: [],
            listsY: [],
            listsN: [],
            rhDetails: {},
            curRh: 0,
            selItems: [],
            dataForm: {},
            pageInfo: {
                size: 100,
                current: 1,
                total: 0,
            },
            rhTypeNum: null,
            showDrawer: false,
            curItemDetail: {},
            dataColumn: [
                {
                    title: '指标(功能名称)',
                    key: 'name',
                    render: (h, params) => {
                        const item = params.row;
                        return h("div", item.name || "-");
                    },
                },
                {
                    title: '数据类型',
                    key: 'dataType',
                    render: (h, params) => {
                        const item = params.row;
                        return h("div", item.dataType || "-");
                    },
                },
                {
                    title: '标识符',
                    key: 'identifier',
                    render: (h, params) => {
                        const item = params.row;
                        return h("div", item.identifier || "-");
                    },
                }
            ],
            searchTimer: null,
            initPop: true,
            lubiacation:true, //润滑点是否编辑
            updatecode:"" //修改的润滑点名称
        }
    },
    watch:{
       rhDetails(newvalue){
         
           this.updatecode=newvalue.code
       }  
    },
    methods: {
        getLists(page) {
            this.$store.state.spinShow = true
            if(page) this.pageInfo.current = page //分页处理
            api.axss(
                'post',
                '/ocm-oil-site/oil-site-type/page',
                {...this.pageInfo, ...this.dataForm}
            ).then(res=>{
                if(res.code === '00000') {
                    const datas = res.data
                   
                    this.dataLists = datas.records
                    this.listsY = []
                    this.listsN = []
                    this.dataLists.forEach((item,index) => {
                        if(item.status === 1) this.listsY.push(item)
                        else this.listsN.push(item)
                    });
               
                    if(this.listsY.length || !this.listsN.length) this.rhDetails = this.listsY[0] || {} // 默认显示第一个
                    else this.rhDetails = this.listsN[0] || {}
                    this.curRh = 0
                    this.$store.state.spinShow = false
                }
            })
        },
        changeSearch() {
            clearTimeout(this.searchTimer)
            this.searchTimer = setTimeout(() => {
                this.getLists(1)
            }, 500);
        },
        clickTab(tab) {
            this.$store.state.spinShow = true
            if(tab === 'inited') this.rhDetails = this.listsY[0] || {}
            else this.rhDetails = this.listsN[0] || {}
            this.curRh = 0
            setTimeout(() => {
                this.$store.state.spinShow = false
            }, 500)
        },
        showRhDetails(details,index) {
            if(this.curRh === index) return
            this.$store.state.spinShow = true
            setTimeout(() => {
                this.rhDetails = details
                this.curRh = index
                this.$store.state.spinShow = false
            }, 800)
        },
        updatebia(detail){
          const updatecode=this.updatecode
          if(updatecode==detail.code){
            this.lubiacation=true
          }else{
                 this.$Modal.confirm({
                title: `您确定要修改润滑点类型吗？`,
                content: `<div>润滑点类型：${detail.name}</div><div>   请确认无误后点击“确定”。</div> `,
                width: '500px',
                okText: '确定',
                cancelText: '取消',
                onOk: async () => {
                    let bodata= await this.codevertion(detail.id,updatecode)
                    if(bodata.data){
                    let data=await api.axss('post','/ocm-oil-site/oil-site-type/modify',{id: detail.id, code: updatecode})  
                    this.lubiacation=true
                   this.getLists() 
                    }
                  
                   
                },
                onCancel: () =>{
                    this.updatecode=detail.code
                    this.lubiacation=true
                  
                }
            });
          }
        },
        initRhCodePop(detail) {
            if(!this.rhTypeNum) return this.$Message.info('请输入润滑点类型编号')
            this.$Modal.confirm({
                title: `您确定要初始化该润滑点类型吗？`,
                content: `<div>润滑点类型：${detail.name}</div><div>   请确认无误后点击“确定”。</div> `,
                width: '500px',
                okText: '确定',
                cancelText: '取消',
                onOk: () => {
                    this.initRhCode()
                },
                onCancel: () =>{
                    this.rhTypeNum = null
                }
            });
        },
        async codevertion(id,code){
         let data=await api.axss('post','/ocm-oil-site/oil-site-type/initCodeCheck',{id , code })

         if(data.code=="00000"){
              return data
         }else{
            this.$Message.info("类型编号重复")
              return false
         }
      
        },
       async initRhCode() {
            this.$store.state.spinShow = true
            let data= await this.codevertion(this.rhDetails.id,this.rhTypeNum)
           
             if(data.data){
             api.axss(
                'post',
                '/ocm-oil-site/oil-site-type/init',
                {id: this.rhDetails.id, code: this.rhTypeNum}
            ).then(res=>{
               
                if(res.code === '00000') {
                    this.$Message.success('初始化成功')
                    this.rhTypeNum = null
                    this.getLists()
                }else {
                    
                    this.$Message.error(res.msg || '初始化错误')
                }
                this.$store.state.spinShow = false
            })
             }else{
             //  this.$Message.success('编号重复，请修改后再次提交')  
                 this.$store.state.spinShow = false
             }
          
        },
        searchInput(val,name) {
            this.selItems = this.handleSelItem(val,name)
            this.getLists(1)
        },
        changeDate(date,name) {
            this.dataForm.gmtCreateDateStart = date[0]
            this.dataForm.gmtCreateDateEnd = date[1]
            this.selItems = this.handleSelItem(date[0]+'至'+date[1],name)
            this.getLists(1)
        },
        delSelItem(selItem,index) {
            this.dataForm[selItem.name] = null

            //日期需要单独处理
            if(selItem.name === 'date') {
                delete this.dataForm.gmtCreateDateStart
                delete this.dataForm.gmtCreateDateEnd
            }

            this.selItems.splice(index,1)
            this.getLists(1)
        },
        addOil() {
            this.curItemDetail = {} // 重置form
            this.showDrawer = true
        },
        editDetail(item) {
            this.curItemDetail = deepcopy(item)
            this.showDrawer = true
        },
        delItemWarning(item) {
            this.curItemDetail = deepcopy(item)
            this.$Modal.confirm({
                title: '确认删除' + item.name + ' ?',
                onOk: () => {
                    this.delItem()
                },
                onCancel: () => {}
            });
        },
        delItem() {
            api.axss(
                'post',
                `/ocm-oil-site/oil-product/del/${this.curItemDetail.id}`,
            ).then(res=>{
                if(res.code === '00000') {
                    this.$Message.success('删除成功')
                    this.curItemDetail = {}
                    this.getLists()
                }
            })
        },
        closeDrawer() {
            this.showDrawer = false
            this.curItemDetail = {};
        },
        resetData() {
            this.reset('dataForm')
            this.getLists(1)
        },
        reset(key) {
            this.selItems = []
            Object.keys(this[key]).forEach(item => {
                this[key][item] = "";
            });
        }
    },
    mounted() {
        this.getLists()
        this.$store.dispatch('dataCenter','brand') // 加载油品品牌
    }
};
</script>

<style lang='less'>
.knowledge-rhtype {
    .ivu-alert-info {
        margin-bottom: 20px;
        border: none;
        background: #e5f1fb;
        padding-top: 10px;
        .ivu-icon {
            color: #0c479d;
        }
    }
    .rhcontentWrap {
        display: flex;
        .left-types {
            flex: 0 0 20%;
            min-height: 460px;
            overflow: auto;
            .ivu-input-wrapper {
                .ivu-input {
                    border: none;
                    border-bottom: 1px solid #dcdee2;
                    border-radius: 0;
                    box-shadow: none!important;
                }
            }
            .ivu-tabs-nav-wrap {
                .ivu-tabs-nav {
                    .ivu-tabs-tab {
                        padding: 16px;
                    }
                }
            }
            .rh-lists {
                overflow: auto;
                li {
                    padding: 10px 18px;
                    cursor: pointer;
                    white-space: nowrap;
                    &:hover {
                        background-color: #f5f5f5;
                    }
                    &.cur {
                        background-color: #f5f5f5;
                    }
                }
            }
            .no-datas {
                font-size: 14px;
                color: #ccc;
                text-align: center;
                padding: 50px 0;
            }
        }
        .right-table {
            flex: auto;
            border-left: 1px solid #dcdee2;
            padding-left: 20px;
            .rh-title {
                font-size: 18px;
                color: #333;
            }
            .rh-desc {
                display: flex;
                padding: 20px 0 10px;
                &>p {
                    flex: 0 0 50%;
                    span {
                        display: block;
                        color: #888;
                        padding: 4px 0;
                    }
                }
            }
            .rh-init {
                .rh-tit {
                    color: #888;
                    padding: 8px 0;
                    
                }
                .btn-init {
                    cursor: pointer;
                    font-size: 14px;
                    color: #0c479d;
                    padding: 4px 10px;
                }
            }
        }
    }
    .rh-update{
         display: flex;
         align-items: center;
         span{
             margin-left: 20px;
             color: #0c479d;
             cursor: pointer;
         }
                    }
}
</style>